<template>
  <modal
    :title="'Match Country (' + setModel.Name + ' - ' + setModel.Name1 + ')'"
    :size="'md'"
    @close="$emit('close')"
  >
    <template #content>
      <loadArea v-if="countries == null"></loadArea>
      <Form
        method="dialog"
        v-slot="{ errors }"
        v-if="countries != null"
        class="floating-labels p-1rem row"
        ref="form"
      >
        <div class="col-md-12">
          <selectBox
            :title="'CountryId'"
            :as="'select'"
            :disabled="countries.length == 0"
            :buttons="true"
            v-model="model.CountryId"
            :rules="{ required: true }"
            :errors="errors"
            @keydown.enter="save"
          >
            <template #search>
              <input
                type="text"
                placeholder="Ara"
                class="form-control small"
                v-model="searchCountry"
              />
            </template>
            <template #input>
              <template v-for="item in countries">
                <option
                  :value="item.Id"
                  v-if="
                    item.Name.toUpperCase().indexOf(
                      searchCountry.toUpperCase()
                    ) > -1
                  "
                  :key="item.Code"
                  >{{ item.Name }}</option
                >
              </template>
            </template>
            <template #buttons>
              <button
                type="button"
                @click="addCountriesOpen = true"
                class="btn waves-effect waves-light btn-success"
              >
                <i class="fas fa-plus"></i>
              </button>
            </template>
          </selectBox>
        </div>
        <div class="col-md-12">
          <formGroup
            :title="'Name'"
            v-model="model.Name"
            :errors="errors"
            :rules="{ required: true, max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'Code1'"
            v-model="model.Code1"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'Code2'"
            v-model="model.Code2"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
        <div class="col-md-4">
          <formGroup
            :title="'Code3'"
            v-model="model.Code3"
            :errors="errors"
            :rules="{ max: 50 }"
            @keydown.enter="save"
          ></formGroup>
        </div>
      </Form>
    </template>
    <template #foot>
      <Btn
        class="btn-success btn-md"
        @click="save"
        :disabled="countries == null"
        :process="process"
        >{{ "Match Country" }}</Btn
      >
    </template>
  </modal>
  <addCountries
    v-if="addCountriesOpen"
    @close="addCountriesOpen = false"
    @add="countries.push({ Code: $event.Code, Name: $event.Name })"
  ></addCountries>
</template>

<script>
import addCountries from "@/views/countries/upsert";
import selectBox from "@/components/formGroup/selectBox";
export default {
  props: {
    setModel: Object,
    operators: Array,
  },
  components: { addCountries, selectBox },
  data() {
    return {
      model: {
        Id: null,
        OperatorId: null,
        Code1: null,
        Code2: null,
        Code3: null,
        Name: null,
        CountryId: null,
      },
      searchCountry: "",
      process: false,
      countries: null,
      addCountriesOpen: false,
    };
  },
  watch: {
    // selectCountry(){
    //     this.model.CountryId=this.selectCountry.Id;
    //     this.model.Code1=this.selectCountry.ISO2;
    //     this.model.Code2=this.selectCountry.ISO3;
    //     this.model.Code3=this.selectCountry.CurrencyCode;
    // }
  },
  created() {
    if (this.setModel != undefined) {
      this.model.Id = this.setModel.Id;
      this.model.OperatorId = this.setModel.OperatorId;
      this.model.Code1 = this.setModel.Code1;
      this.model.Code2 = this.setModel.Code2;
      this.model.Code3 = this.setModel.Code3;
      this.model.Name = this.setModel.Name;
      this.model.CountryId = this.setModel.CountryId;
    }
    this.$appAxiosAdmin.get(`Countries`).then((response) => {
      this.countries = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .put(`TOURSCOPE/OperatorCountries`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text: "Country successfully matched",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              this.$emit("match", response.data);
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$swal({
                icon: "error",
                title: "Error",
                text: err.response.data.title,
                timer: 2000,
                confirmButtonText: "Okey",
              });
            });
        }
      });
    },
  },
};
</script>

<style></style>
